document.addEventListener('DOMContentLoaded', function () {
    const svgContainers = document.querySelectorAll('.svg-container')
    svgContainers.forEach((container) => {
        const svgUrl = container.dataset.svgUrl
        fetch(svgUrl)
            .then((response) => response.text())
            .then((svgContent) => {
                container.innerHTML = svgContent
            })
    })
})
